import LoginForm from './LoginForm'
import Footer from '../../components/Footer'

function Login() {
  return (
    <div className='login-page'>
      <LoginForm/>
      <Footer/>
    </div>
  )
}

export default Login